import { decryptResponse, encryptResponse } from "../components/encryptResp";

const api_key = process.env.REACT_APP_API_KEY;

// Standardize response handling for all API calls
const handleApiResponse = async (response) => {
    try {
        const data = await response.json();
        return decryptResponse(data.encrypted, data.iv);
    } catch (error) {
        console.error('API Response Error:', error);
        return { status: false, message: "Internet Server Error" };
    }
};
const AdminAuthCheck = async () => {
    const token = localStorage.getItem('admin_number_store');
    try {
        const resp = await fetch('/api/admin/Authorization', {
            method: "GET",
            headers: {
                'x-api-key': api_key,
                'Authorization': `Bearer ${token}`,
            },
        })
        return handleApiResponse(resp);
    } catch (error) {
        console.error("Admin Auth Check" + error);
        return { status: false, message: "Internet Server Error" };
    }
}


const AdminLogin = async (body) => {
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch('/api/admin/login', {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                'x-api-key': api_key
            },
            body: JSON.stringify({ encryptedData: encrypted })
        })
        return handleApiResponse(resp);
    } catch (error) {
        console.error("Admin Login" + error);
        return { status: false, message: "Internet Server Error" };
    }
}

const LoginOtp = async (body) => {
    const token = localStorage.getItem('token');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/admin/login/otp`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key
            },
            body: JSON.stringify({ encryptedData: encrypted })
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
};

const GetAdminData = async () => {
    const token = localStorage.getItem('admin_number_store');

    try {
        const resp = await fetch(`/api/admin/AdminData`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const AdminProfileUpdate = async (body) => {
    const token = localStorage.getItem('admin_number_store');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/admin/Profile/Update`, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key
            },
            body: JSON.stringify({ encryptedData: encrypted })
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const ForgetPw = async (body) => {
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/admin/ForgetPw`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                'x-api-key': api_key
            },
            body: JSON.stringify({ encryptedData: encrypted })
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
};

const ForgetPwOtp = async (body) => {
    const token = localStorage.getItem('forgetPw');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/admin/ForgetPwOtp`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                'Authorization': `Barear ${token}`,
                'x-api-key': api_key
            },
            body: JSON.stringify({ encryptedData: encrypted })
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
};

const ResetPassword = async (body) => {
    const token = localStorage.getItem('forgetPw');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/admin/NewPassword`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                'Authorization': `Barear ${token}`,
                'x-api-key': api_key
            },
            body: JSON.stringify({ encryptedData: encrypted })
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
};

// Admin Dashboard
const getAdminDashboard = async () => {
    const token = localStorage.getItem('admin_number_store');
    try {
        const resp = await fetch(`/api/admin/dashboard`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

// Api Config
const getApiConfig = async () => {
    const token = localStorage.getItem('admin_number_store');
    try {
        const resp = await fetch(`/api/mobile/admin/api-config`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const putApiConfig = async (body) => {
    const token = localStorage.getItem('admin_number_store');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/mobile/admin/api-config`, {
            method: "PUT",
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

// Mobile
const mobileFetch = async (num) => {
    const token = localStorage.getItem('admin_number_store');
    try {
        const resp = await fetch(`/api/mobile/fetch?mobile=${num}`, {
            method: "GET",
            headers: {
                'x-api-key': api_key,
                'Authorization': `Bearer ${token}`,
            },
        })
        return handleApiResponse(resp);
    } catch (error) {
        console.error("Admin Login" + error);
        return { status: false, message: "Internet Server Error" };
    }
}

const mobileGet = async (query) => {
    const token = localStorage.getItem('admin_number_store');
    try {
        const resp = await fetch(`/api/mobile/admin?search=${query}`, {
            method: "GET",
            headers: {
                'Content-Type': 'application/json',
                'x-api-key': api_key,
                'Authorization': `Bearer ${token}`,
            },
        })
        return handleApiResponse(resp);
    } catch (error) {
        console.error("Mobile Get" + error);
        return { status: false, message: "Internet Server Error" };
    }
}

const mobileDelete = async (body) => {
    const encrypted = encryptResponse(body);
    const token = localStorage.getItem('admin_number_store');
    try {
        const resp = await fetch('/api/mobile/admin', {
            method: "DELETE",
            headers: {
                'Content-Type': 'application/json',
                'x-api-key': api_key,
                'Authorization': `Bearer ${token}`,
            },
            body: JSON.stringify({ encryptedData: encrypted })
        })
        return handleApiResponse(resp);
    } catch (error) {
        console.error("Admin Login" + error);
        return { status: false, message: "Internet Server Error" };
    }
}

// Server Load Checker
const GetServerLoadCheck = async () => {
    const token = localStorage.getItem('admin_number_store');
    try {
        const resp = await fetch(`/api/app/server/load/check`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

// Ip Whitelist Management can be added here similarly
const addIpToWhitelist = async (body) => {
    const token = localStorage.getItem('admin_number_store');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch('/api/ipmanager/admin', {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                'x-api-key': api_key,
                'Authorization': `Bearer ${token}`,
            },
            body: JSON.stringify({ encryptedData: encrypted })
        })
        return handleApiResponse(resp);
    }
    catch (error) {
        console.error("Add IP to Whitelist" + error);
        return { status: false, message: "Internet Server Error" };
    }
}

const removeIpFromWhitelist = async (body) => {
    const token = localStorage.getItem('admin_number_store');
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch('/api/ipmanager/admin', {
            method: "DELETE",
            headers: {
                'Content-Type': 'application/json',
                'x-api-key': api_key,
                'Authorization': `Bearer ${token}`,
            },
            body: JSON.stringify({ encryptedData: encrypted })
        })
        return handleApiResponse(resp);
    }
    catch (error) {
        console.error("Remove IP from Whitelist" + error);
        return { status: false, message: "Internet Server Error" };
    }
}

const fetchIpWhitelist = async () => {
    const token = localStorage.getItem('admin_number_store');
    try {
        const resp = await fetch('/api/ipmanager/admin', {
            method: "GET",
            headers: {
                'x-api-key': api_key,
                'Authorization': `Bearer ${token}`,
            },
        })
        return handleApiResponse(resp);
    } catch (error) {
        console.error("Fetch IP Whitelist" + error);
        return { status: false, message: "Internet Server Error" };
    }
}


const Calling = {
    AdminLogin, AdminAuthCheck, ResetPassword, LoginOtp, GetAdminData, AdminProfileUpdate, ForgetPw, ForgetPwOtp,
    getApiConfig, putApiConfig,
    mobileFetch,mobileGet,mobileDelete,
    GetServerLoadCheck,
    getAdminDashboard,
    addIpToWhitelist, removeIpFromWhitelist, fetchIpWhitelist,
 }

export default Calling;